import actions from './clientOnboardingManagement/actions'
import mutations from './clientOnboardingManagement/mutations'
import getters from './clientOnboardingManagement/getters'

const state = {
  title: 'clientOnboardingManagement',
  applicationListLoading: true,
  applicationListMessage: '',
  applicationList: [],
  recipientsListLoading: true,
  recipientsListMessage: '',
  recipientsList: [],
  batchLoading: true,
  originalRecipientsList: [],
  formInvalid: false,
  resendEmailLoading: false

}

export const clientOnboardingManagement = {
  namespaced: false,
  state,
  mutations,
  actions,
  getters
}
